export const meditation = ['512 512', `
  <g>
  	<g>
  		<path d="M510.633,312.157c-1.655-2.867-4.6-4.753-7.896-5.057c-2.145-0.197-47.182-4.084-99.312,11.3    c26.328-66.804,20.892-130.565,20.604-133.685c-0.304-3.296-2.189-6.241-5.057-7.896c-2.867-1.655-6.359-1.816-9.367-0.43    c-2.376,1.094-53.024,24.801-96.25,73.73c-12.294-68.888-47.239-119.028-49.03-121.56c-1.911-2.703-5.016-4.31-8.328-4.31    c-3.312,0-6.416,1.607-8.328,4.31c-1.791,2.531-36.734,52.671-49.03,121.56c-43.226-48.93-93.874-72.636-96.25-73.73    c-3.006-1.385-6.5-1.225-9.367,0.43s-4.753,4.6-5.057,7.896c-0.289,3.121-5.725,66.883,20.604,133.687    c-52.132-15.383-97.17-11.499-99.31-11.302c-3.296,0.304-6.241,2.19-7.896,5.057s-1.816,6.359-0.43,9.367    c1.384,3.007,34.718,74.09,104.598,114.435c51.68,29.838,107.921,33.957,135.047,33.957c7.857,0,13.268-0.346,15.42-0.512    c2.152,0.167,7.56,0.512,15.42,0.512c27.128,0,83.37-4.122,135.047-33.957c69.88-40.345,103.213-111.428,104.598-114.435    C512.45,318.518,512.288,315.024,510.633,312.157z M115.733,418.294c-46.299-26.731-75.771-69.419-88.691-91.331    c19.957,0.158,56.079,2.755,93.151,16.865c1.516,2.888,3.091,5.771,4.748,8.639c26.426,45.771,64.75,77.386,92.361,95.908    C189.735,445.993,151.155,438.746,115.733,418.294z M142.607,342.268c-30.576-52.959-34.747-112.22-34.81-139.876    c20.007,11.603,57.699,36.729,87.32,75.55c-0.459,6.178-0.713,12.457-0.713,18.83c0,55.065,18.368,103.46,33.547,134.055    C202.242,413.426,166.706,384.01,142.607,342.268z M256,439.788c-14.113-24.479-41.197-79.709-41.197-143.016    S241.889,178.233,256,153.757c14.113,24.479,41.197,79.709,41.197,143.016S270.11,415.312,256,439.788z M317.595,296.771    c0-6.372-0.254-12.652-0.713-18.829c29.632-38.833,67.34-63.965,87.341-75.561c-0.037,27.613-4.169,86.782-34.829,139.886    c-24.03,41.622-59.583,71.06-85.315,88.497C299.252,400.166,317.595,351.801,317.595,296.771z M396.267,418.294    c-35.422,20.45-74.002,27.698-101.568,30.081c27.61-18.522,65.934-50.137,92.359-95.907c1.656-2.869,3.233-5.752,4.75-8.642    c36.96-14.064,73.145-16.67,93.138-16.844C472.018,348.904,442.55,391.572,396.267,418.294z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M173.386,129.797c-16.59,0-30.088,13.498-30.088,30.088s13.498,30.088,30.088,30.088s30.088-13.498,30.088-30.088    S189.976,129.797,173.386,129.797z M173.386,169.574c-5.342,0-9.689-4.347-9.689-9.689s4.347-9.689,9.689-9.689    s9.689,4.347,9.689,9.689S178.729,169.574,173.386,169.574z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M338.613,129.797c-16.59,0-30.088,13.498-30.088,30.088s13.498,30.088,30.088,30.088c16.59,0,30.088-13.498,30.088-30.088    S355.203,129.797,338.613,129.797z M338.613,169.574c-5.342,0-9.689-4.347-9.689-9.689s4.347-9.689,9.689-9.689    c5.342,0,9.689,4.347,9.689,9.689S343.956,169.574,338.613,169.574z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M256,42.083c-16.59,0-30.088,13.498-30.088,30.088S239.41,102.259,256,102.259s30.088-13.498,30.088-30.088    S272.59,42.083,256,42.083z M256,81.86c-5.342,0-9.689-4.347-9.689-9.689s4.347-9.689,9.689-9.689s9.689,4.347,9.689,9.689    S261.342,81.86,256,81.86z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M266.206,368.497c-5.316-1.86-11.134,0.938-12.998,6.254c-1.253,3.578-2.09,5.565-2.094,5.572    c-2.208,5.183,0.204,11.174,5.386,13.381c1.303,0.555,2.659,0.818,3.993,0.818c3.964,0,7.735-2.326,9.388-6.204    c0.108-0.255,1.105-2.614,2.578-6.823C274.323,376.179,271.522,370.359,266.206,368.497z"/>
  	</g>
  </g>
  <g>
  	<g>
  		<path d="M286.127,291.364c-0.181-5.63-4.905-10.05-10.521-9.866c-5.63,0.181-10.047,4.892-9.866,10.522    c0.56,17.412-0.977,35.317-4.569,53.215c-1.109,5.523,2.47,10.898,7.993,12.007c0.677,0.136,1.351,0.201,2.017,0.201    c4.759,0,9.016-3.349,9.989-8.195C285.07,329.814,286.737,310.34,286.127,291.364z"/>
  	</g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
`]
